import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Term } from '../models/terms.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalTermsService {
  private readonly API_URL = '/external/umanager/terms';
  private apiService = inject(ApiService);


  getTermsByType(type: string, name?: string): Observable<Term> {
    let params = new HttpParams().set('type', type);
    const trimmedName = name?.trim();
    if (trimmedName) {
      params = params.set('name', trimmedName);
    }
    return this.apiService.get<Term>(this.API_URL, { params });
  }
}